import {Component} from "react";
import {Stack} from "@mui/material";
import AnnotationLayer from "./AnnotationLayer";
import DeepBioLayer from "./DeepBioLayer";
import IHCLayer from "./IHCLayer";
import FieldLayer from "./FieldLayer";
import DeepBioAnalysisLayer from "./DeepBioAnalysisLayer";
import IHCResultLayer from "./IHCResultLayer";
import TileAnnotationLayer from "../tileLayers/TileAnnotationLayer";
import {connect} from "react-redux";
import WBCLayer from "./WBCLayer";
import RBCLayer from "./RBCLayer";
import PLTLayer from "./PLTLayer";

class Layers extends Component {

	render() {
		return <Stack direction={"column"} padding={1} bgcolor={"rgba(51, 4, 112,0.8)"}>
			{!this.props.tileMapEnable && <AnnotationLayer {...this.props} />}
			<DeepBioLayer {...this.props} />
			<IHCLayer {...this.props} />
			{this.props.bloodMapEnable && <FieldLayer {...this.props} />}
			{this.props.bloodMapEnable && <WBCLayer {...this.props} />}
			{this.props.bloodMapEnable && <RBCLayer {...this.props} />}
			{this.props.bloodMapEnable && <PLTLayer {...this.props} />}
			<DeepBioAnalysisLayer {...this.props} />
			<IHCResultLayer {...this.props} />
			{this.props.tileMapEnable && <TileAnnotationLayer {...this.props} />}
		</Stack>;
	}
}

const mapStateToProps = (state) => {
	let {tileMapEnable, bloodMapEnable} = state.gammaStateReducer;
	return {tileMapEnable, bloodMapEnable};
}

export default connect(mapStateToProps)(Layers);
